import { render } from "./none.vue?vue&type=template&id=428ddbcb"
const script = {}

import exportComponent from "E:\\SonPhat\\Project\\QLBX_WEB\\CauHinhHoaDonDienTu_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__